<template>
  <input type="text" class="input-value" :value="condition.value" @change="store.commit(`${this.storeId}.value`, $event.target.value)" placeholder="Value" />
</template>

<script>
export default {
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    condition() {
      return this.config?.condition || {}
    }
  },
  methods: {
    //
  },
  props: {
    config: Object
  }
}
</script>
